export default __webpack_public_path__ + "static/anatomy-c381171cd1b8e4aa26a5b0db22ee29c8.png";